import ContaPagar from "../contaPagar/ContaPagar";

export default class SolicitarAntecipacaoRequest {
    novoVencimento: Date;
    contasPagar: ContaPagar[]

    constructor(novoVencimento: Date, contasPagar: ContaPagar[]) {
        this.novoVencimento = novoVencimento;
        this.contasPagar = contasPagar;
    }
}